import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';

import { useEmspBoInvoiceContext } from '../emsp-bo-invoice.context';

export const EmspBoInvoiceEmspUserDetailsController = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const invoice = useEmspBoInvoiceContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card flex={1} gap={GapEnum.M}>
      <AccentTitle
        icon="user-01"
        as={HeadingEnum.H2}
        text={t(
          'delmonicos-shared-sdk.outputs-emsp-user-invoice-base.emsp-user',
        )}
      />
      <Stack justifyContent="space-between">
        <Text bold>
          {t('delmonicos-shared-sdk.outputs-emsp-user.first-name')}{' '}
          {t('delmonicos-shared-sdk.outputs-emsp-user.last-name')}
        </Text>
        <Text>
          {invoice.emspUser
            ? `${invoice.emspUser.firstName ?? ''} ${
                invoice.emspUser.lastName ?? ''
              }`.trim() || '-'
            : '-'}
        </Text>
      </Stack>
      <Stack justifyContent="space-between">
        <Text bold>{t('delmonicos-shared-sdk.outputs-emsp-user.email')}</Text>
        <Text>{invoice.emspUser?.email ?? '-'}</Text>
      </Stack>
      {invoice.emspCustomer && (
        <Stack justifyContent="space-between">
          <Text bold>
            {t('delmonicos-shared-sdk.outputs-invoice.emsp-customer')}
          </Text>
          <Text>{invoice.emspCustomer.name}</Text>
        </Stack>
      )}
    </Card>
  );
};
